var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.profileData != null)?_c('interviewee-card',{attrs:{"user":_vm.profileData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }